// for next usage
export class Config {
    public static ADCORE_CONTACT_FORM_DIALOG_MODAL = 'ADCORE-CONTACT-FORM-DIALOG-MODAL';
    public static ADCORE_CONTACT_FORM_COOKIE = 'adcoreContactFormToken';
    public static ADCORE_CONTACT_FORM_COOKIE_30_MINUTES = 'adcoreContactFormToken_30_minutes';
}



// WEBPACK FOOTER //
// ./src/lib/config.ts